// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-message[data-v-2bdcd66d]{white-space:pre-line}", ""]);
// Exports
module.exports = exports;
